// Temperatures can be entered in either scale and only the number is stored, so the
// value says which it was: no body is 50°F, nor 98°C. Labelling every reading °F showed
// a normal 36.8°C as "36.8 °F".
export const tempUnit = (v) => (Number(v) <= 50 ? '°C' : '°F');
export const formatTemp = (v) => `${v} ${tempUnit(v)}`;
